export type Colors = 'green' | 'red' | 'default';

export const COLORS: Record<Colors, string> = {
  green: 'success.main',
  red: 'error.main',
  default: 'text.dark',
};
